// this is an autogenerated file from DesignSystem/PaymentProvider/PaymentProviderLocation/PaymentProviderLocationSelector/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_PaymentProvider_PaymentProviderLocation_PaymentProviderLocationSelector_Content($xid: String!) {
  payments_provider_location_accounts(
    where: {
      is_default: { _eq: true }
      # TODO: review data, we shouldn't need this filter
      # but staging returns the PC
      location: { level: { _eq: "location" } }
      status: { _eq: active }
      xid: { _eq: $xid }
    }
    order_by: { location: { name: asc } }
  ) {
    id
    fee_mode
    card_fee_percent
    ach_fee_percent
    location {
      id
      _id
      name
    }
  }
}

`